/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_dnamw_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How is oligo molecular weight calculated?`)
};

const es_dnamw_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cómo se calcula el peso molecular de un oligo?`)
};

const de_dnamw_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie wird das Molekulargewicht eines Oligos berechnet?`)
};

const nl_dnamw_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoe wordt het molecuulgewicht van een oligo berekend?`)
};

const fr_dnamw_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comment la masse moléculaire d'un oligo est-elle calculée ?`)
};

const it_dnamw_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Come si calcola il peso molecolare dell'oligo?`)
};

const pt_br2_dnamw_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como o peso molecular de um oligo é calculado?`)
};

const pt_dnamw_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como se calcula a massa molecular de um oligonucleótido?`)
};

const ja_dnamw_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オリゴの分子量はどのように計算されますか？`)
};

const zh_dnamw_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`寡核苷酸分子量是如何计算的？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const dnamw_faq_q1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.dnamw_faq_q1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("dnamw_faq_q1", locale)
	if (locale === "en") return en_dnamw_faq_q1(inputs)
	if (locale === "es") return es_dnamw_faq_q1(inputs)
	if (locale === "de") return de_dnamw_faq_q1(inputs)
	if (locale === "nl") return nl_dnamw_faq_q1(inputs)
	if (locale === "fr") return fr_dnamw_faq_q1(inputs)
	if (locale === "it") return it_dnamw_faq_q1(inputs)
	if (locale === "pt-BR") return pt_br2_dnamw_faq_q1(inputs)
	if (locale === "pt") return pt_dnamw_faq_q1(inputs)
	if (locale === "ja") return ja_dnamw_faq_q1(inputs)
	return zh_dnamw_faq_q1(inputs)
};